import { render } from "./VerticalAd.vue?vue&type=template&id=01fd6a0a&scoped=true&ts=true"
import script from "./VerticalAd.vue?vue&type=script&lang=ts"
export * from "./VerticalAd.vue?vue&type=script&lang=ts"

import "./VerticalAd.vue?vue&type=style&index=0&id=01fd6a0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd6a0a"]])

export default __exports__